<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <div class="divider divider--gold mb-3"></div>

                    <h1 class="mb-5 font-h1 font-thin">
                        EDIT <span class="text-uppercase">{{ event.name }}</span>
                    </h1>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
                            <custom-select
                                :options="client_options"
                                :defaultvalue="form.client_id"
                                :heading="'Select a client'"
                                @option-selected="(option) => form.client_id = option.value">
                            </custom-select>

<!--                            <b-form-select -->
<!--                                v-model="form.client_id"-->
<!--                                :options="client_options"-->
<!--                                class=mb-2>-->
<!--                                -->
<!--                                <template slot="first">-->
<!--                                    <option :value="null" disabled>None</option>-->
<!--                                </template>-->
<!--                                -->
<!--                            </b-form-select>-->

                            <b-form-input
                                class="tb-form-field mb-3 font-h3"
                                placeholder="Event Name"
                                type="text"
                                v-model="form.name"
                                required>
                            </b-form-input>

                            <label class="mb-2">
                                Your WhatsApp group join link. This can be found by creating a group in WhatsApp,
                                and generating a join link in the "group info" section.
                            </label>

                            <b-form-input
                                class="tb-form-field mb-3 font-h3"
                                placeholder="WhatsApp Group Join Link"
                                type="text"
                                v-model="form.whatsapp_group_join_link">
                            </b-form-input>

                            <div class="my-3">
                                <label class="mb-2">
                                    Is this a paid event?
                                </label>

                                <checkbox :initialvalue="form.requires_payment" @box-checked="(trueFalse) => form.requires_payment = trueFalse"></checkbox>
                            </div>

<!--                            <b-form-checkbox class="my-3" v-model="form.requires_payment" switch>-->
<!--                                Is this a paid event? ({{ form.requires_payment ? "Yes" : "No" }})-->
<!--                            </b-form-checkbox>-->

                            <div class="my-3" v-show="form.requires_payment">
                                <label>
                                    Cost
                                </label>

                                <b-form-input
                                    class="tb-form-field mb-3 font-h3"
                                    placeholder="cost"
                                    type="number"
                                    v-model="form.cost"
                                    step=0.01
                                    required>    
                                </b-form-input>

                                <label class="mb-2">
                                    Does this event require payment upfront?
                                </label>

                                <checkbox :initialvalue="form.requires_payment_upfront" @box-checked="(trueFalse) => form.requires_payment_upfront = trueFalse"></checkbox>

<!--                                <b-form-checkbox v-model="form.requires_payment_upfront" switch>-->
<!--                                    Does this event require payment upfront? ({{ form.requires_payment_upfront ? "Yes" : "No" }})-->
<!--                                </b-form-checkbox>-->
                            </div>

<!--                            <label>-->
<!--                                Description-->
<!--                            </label>-->

                            <div class="border-wrapper mt-4">
                                <div class="border-wrapper__heading mb-0">
                                    <label>
                                        DESCRIPTION
                                    </label>
                                </div>

                                <vue-editor
                                    v-model="form.description"
                                    :editorToolbar="
                                    [
                                        ['bold', 'italic', 'underline'],
                                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                        ['code-block'],
                                        [{align: ''}, {align: 'center'}, {align: 'right'}]
                                  ]"></vue-editor>
                            </div>
                        </b-form-group>

                        <b-form-group>
                            <b-row>
                                <b-col>
                                    <div class="border-wrapper">
                                        <div class="border-wrapper__heading">
                                            <label>
                                                UPLOAD IMAGE
                                            </label>
                                        </div>

                                        <simple-image-picker
                                            :src="form.image"
                                            :height="image_dimensions.large.height"
                                            :width="image_dimensions.large.width"
                                            :text="'choose image'"
                                            @image-picked="(base64) => { form.image_base64 = base64; }">
                                        </simple-image-picker>
                                    </div>

<!--                                    <span class="float-left">-->
<!--                                        <label>-->
<!--                                            Event image-->
<!--                                        </label>-->

<!--                                        <simple-image-picker-->
<!--                                            :src="form.image"-->
<!--                                            :height="image_dimensions.large.height"-->
<!--                                            :width="image_dimensions.large.width"-->
<!--                                            @image-picked="(base64) => { form.image_base64 = base64; }">-->
<!--                                        </simple-image-picker>-->

<!--                                        &lt;!&ndash; <image-picker-->
<!--                                            :current_image_url="form.image"-->
<!--                                            :height="image_dimensions.large.height"-->
<!--                                            :width="image_dimensions.large.width"-->
<!--                                            @image-picked="(file) => { form.image_base64 = file; }">-->
<!--                                        </image-picker> &ndash;&gt;-->
<!--                                    </span>-->
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-form-group>
                            <b-row>
                                <b-col>
                                    <div class="border-wrapper">
                                        <div class="border-wrapper__heading">
                                            <label>
                                                VENUE ADDRESS
                                            </label>
                                        </div>

                                        <address-selector
                                            :address-object="addressObject"
                                            @changed="addressChanged">
                                        </address-selector>
                                    </div>

<!--                                    <address-selector -->
<!--                                        :address-object="addressObject"-->
<!--                                        @changed="addressChanged"></address-selector>-->
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-button class="mt-3" type="submit" variant="primary tb-button tb-button--blue font-h3 font-thin mt-4">
                            SAVE EVENT
                        </b-button>

<!--                        <b-button class="mt-3" type="submit" variant="primary">-->
<!--                            Save-->
<!--                        </b-button>-->
                    </b-form>

                    <div class="border-wrapper mt-4">
                        <div class="border-wrapper__heading">
                            <label>
                                Questions
                            </label>
                        </div>

                        <editable-question-list
                            :event-id="event.id"
                            :questions="event.questions"
                            @changed="questions => { this.questions = questions; }">
                        </editable-question-list>
                    </div>

<!--                    <div class="my-5">-->
<!--                        <h3 class="mb-3">-->
<!--                            Questions-->
<!--                        </h3>-->

<!--                        <editable-question-list -->
<!--                            :event-id="event.id"-->
<!--                            :questions="event.questions"-->
<!--                            @changed="questions => { this.questions = questions; }">-->
<!--                        </editable-question-list>-->
<!--                    </div>-->

                    <div class="border-wrapper mt-4">
                        <div class="border-wrapper__heading">
                            <label>
                                Itinerary
                            </label>
                        </div>

                        <itinerary-form :event="event" :days="event.days"></itinerary-form>
                    </div>

<!--                    <div class="my-5">-->
<!--                        <h3>-->
<!--                            Itinerary-->
<!--                        </h3>-->

<!--                        <itinerary-form :event="event" :days="event.days"></itinerary-form>-->
<!--                    </div>-->
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import moment from 'moment';
    import { VueEditor } from "vue2-editor";
    import datePicker from 'vue-bootstrap-datetimepicker';
    // import ImagePicker from '@/components/ImagePicker.vue';
    import SimpleImagePicker from '@/components/SimpleImagePicker.vue';
    import AddressSelector from '@/components/AddressSelector.vue';
    import EditableQuestionList from '@/components/EditableQuestionList.vue';
    import ItineraryForm from '@/components/ItineraryForm.vue';
    import clientRepository from "@/repository/clients";
    import eventRepository from "@/repository/events";
    import Checkbox from "@/components/Checkbox";
    import CustomSelect from "@/components/CustomSelect";

    let date_format = "DD-MM-YYYY HH:mm";

    export default {
        components: {
            // ImagePicker,
            SimpleImagePicker,
            datePicker,
            AddressSelector,
            EditableQuestionList,
            ItineraryForm,
            VueEditor,
            Checkbox,
            CustomSelect
        },

        props: ['id'],

        data() {
            return {
                is_paid_event: false,
                event: null,
                client: null,
                clients: [],
                questions: [],
                image_dimensions: {
                    large: {
                        height: 400,
                        width: 800
                    },
                    small: {
                        height: 200,
                        width: 300
                    },
                },
                errors: {},
                loaded: false,
                form: null
            }
        },

        computed: {
            client_options() {
                return this.clients.map((client) => {
                    return {
                        value: client.id,
                        text: client.name
                    }
                });
            },

            addressObject() {
                return {
                    address: this.form.address_address,
                    lat: this.form.address_lat,
                    lng: this.form.address_lng
                }
            }
        },

        methods: {
            addressChanged(address) {
                this.form.address_address = address.address;
                this.form.address_lat = address.lat;
                this.form.address_lng = address.lng;
            },

            onSubmit() {
                eventRepository.update(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Event Edited',
                            text: 'Event successfully edited.'
                        });
                    }).catch(error => {
                        let e = error.response.data.errors;

                        let errors = Object.keys(e).map(key => {
                            return e[key].join("<br/>");
                        }).join("<br/>");

                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Form Errors',
                            text: errors,
                            duration: 10000,
                            width: '500px'
                        });
                    });
            }
        },

        mounted() {
            eventRepository.getById(
                this.id,
                {
                    include: ['client', 'questions', 'days.itinerary_items']
                }
            ).then(response => {
                this.event = response.data;
                this.client = response.data.client;
                this.form = { 
                    ...this.event
                };
                this.loaded = true;
            });

            clientRepository.getAll()
                .then(response => {
                    this.clients = response.data;
                });
        }
    }
</script>

<style scoped lang="scss">
    
</style>